import React from 'react';

const Terms = () => {
  return (
    <div className="bg-cream min-h-screen">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-20">
        <h1 className="font-serif text-4xl md:text-5xl text-charcoal mb-4" data-testid="terms-title">
          Terms & Conditions
        </h1>

        <p className="text-sm text-[#6B665F]">Siyaanish – Live Your Values</p>
        <p className="text-sm text-[#6B665F] mb-8">
          {/* Last updated: [Add date before publishing] */}
        </p>

        <div className="space-y-10 text-[#6B665F] leading-relaxed font-light">

          {/* 1 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">1. Introduction</h2>
            <p>
              Welcome to Siyaanish (“we”, “our”, “us”). These Terms & Conditions govern your
              access to and use of our website and the purchase of products from Siyaanish.
              By accessing our website or placing an order, you agree to be bound by these
              Terms & Conditions. If you do not agree, please do not use our website or services.
            </p>
          </section>

          {/* 2 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">2. Business Information</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Business Name: Siyaanish</li>
              <li>Business Model: Online only</li>
              <li>Registered Location & Jurisdiction: Hyderabad, India</li>
              <li>
                Contact Email:{' '}
                <a href="mailto:info@siyaanish.com" className="text-bronze hover:text-bronze-dark">
                  info@siyaanish.com
                </a>
              </li>
            </ul>
            <p className="mt-3">All legal communication must be made via email only.</p>
          </section>

          {/* 3 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              3. Products & Materials Disclaimer (Important)
            </h2>
            <p>
              Siyaanish works exclusively with eco-friendly, natural, plant-based, breathable,
              and ethically sourced fabrics, many derived from agricultural or plant waste.
              Due to the inherent nature of natural materials:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Variations in colour, texture, weave, thickness, and finish are natural and expected</li>
              <li>Each piece is unique and one of its kind</li>
              <li>Exact replication of any product cannot be guaranteed</li>
            </ul>
            <p className="mt-3">
              These natural variations are not defects, but a feature of conscious and ethical craftsmanship.
            </p>
          </section>

          {/* 4 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              4. Product Availability & Production
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Products may be ready stock, made-to-order, or small-batch limited pieces</li>
              <li>Availability depends on ethical sourcing and material access</li>
              <li>We reserve the right to limit quantities or cancel orders if materials become unavailable</li>
            </ul>
          </section>

          {/* 5 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">5. Pricing & Payment</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>All prices are listed in INR (Indian Rupees)</li>
              <li>Prices are inclusive of applicable GST unless stated otherwise</li>
              <li>Accepted payment methods: UPI, Credit/Debit Cards, Net Banking, Wallets</li>
              <li>Cash on Delivery (COD) is not available</li>
            </ul>
            <p className="mt-3">We reserve the right to change prices at any time without prior notice.</p>
          </section>

          {/* 6 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              6. Order Confirmation & Cancellation
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>An order is confirmed only after successful payment</li>
              <li>Siyaanish may cancel orders due to material unavailability or production limits</li>
            </ul>
            <p className="mt-3">
              If cancelled by us, the amount will be issued as store credit.
            </p>
          </section>

          {/* 7 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">7. Shipping & Delivery</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Shipping coverage: India and International</li>
              <li>Typical dispatch timeline: 7–14 working days</li>
              <li>Delivery timelines are estimates only, not guarantees</li>
            </ul>
            <p className="mt-3">
              Once dispatched, responsibility transfers to the courier partner.
            </p>
          </section>

          {/* 8 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              8. Returns, Replacements & Refunds
            </h2>
            <p className="font-medium">Returns</p>
            <p>Not accepted except for damaged or manufacturing defects.</p>

            <p className="font-medium mt-3">Replacement</p>
            <p>Must be raised within 7 days with proof and unused condition.</p>

            <p className="font-medium mt-3">Refunds</p>
            <p>No cash refunds — store credit only.</p>

            <p className="font-medium mt-3">Exclusions</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Natural variations in colour or texture</li>
              <li>Minor handmade inconsistencies</li>
              <li>Screen or lighting differences</li>
            </ul>
          </section>

          {/* 9 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              9. Fabric, Skin & Care Disclaimer
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Natural fabrics may react differently to skin types</li>
              <li>We are not responsible for allergic reactions</li>
              <li>Customers must follow care instructions</li>
            </ul>
          </section>

          {/* 10 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              10. Intellectual Property
            </h2>
            <p>
              All brand content, designs, text, images, and website materials are the exclusive
              intellectual property of Siyaanish. Unauthorized copying or resale is prohibited.
            </p>
          </section>

          {/* 11 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              11. Limitation of Liability
            </h2>
            <p>
              Siyaanish shall not be liable for indirect or consequential damages.
              Maximum liability shall not exceed the product value purchased.
            </p>
          </section>

          {/* 12 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">12. Force Majeure</h2>
            <p>
              We are not responsible for delays caused by natural disasters, strikes,
              government restrictions, or supply chain disruptions.
            </p>
          </section>

          {/* 13 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              13. Governing Law & Jurisdiction
            </h2>
            <p>
              Governed by the laws of India. Disputes fall under Hyderabad courts.
            </p>
          </section>

          {/* 14 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">14. Communication</h2>
            <p>
              For all support and legal communication, contact{' '}
              <a href="mailto:info@siyaanish.com" className="text-bronze hover:text-bronze-dark">
                info@siyaanish.com
              </a>.
              Legal matters are addressed only via email.
            </p>
          </section>

          {/* 15 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">15. Changes to Terms</h2>
            <p>
              Siyaanish reserves the right to update these Terms at any time.
              Continued use of the website constitutes acceptance of the revised terms.
            </p>
          </section>

          <section className="pt-6">
            <p className="font-serif text-lg text-charcoal">
              Siyaanish — Live Your Values
            </p>
            <p>Luxury that breathes. Ethics that matter.</p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Terms;